(function () {
  'use strict';

  var EVENT_NAME = 'girls_on_campus:cart_item_added_detail';
  var STORAGE_KEY = 'goc_cart_item_adds_v1';
  var MAX_EVENTS = 50;

  function nowIso() {
    return new Date().toISOString();
  }

  function uid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'goc-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  }

  function text(value) {
    return value == null ? '' : String(value);
  }

  function extractSize(item) {
    var options = item && item.options_with_values;
    if (Array.isArray(options)) {
      for (var i = 0; i < options.length; i++) {
        var name = text(options[i] && options[i].name).toLowerCase();
        if (name.indexOf('size') !== -1 || name.indexOf('taille') !== -1 || name.indexOf('pointure') !== -1) {
          return text(options[i].value);
        }
      }
    }
    return text(item && item.variant_title);
  }

  function normalizeItem(item) {
    if (!item) return null;
    var variantId = item.variant_id || item.id || null;
    var productId = item.product_id || null;
    var title = item.product_title || item.title || '';
    var variantTitle = item.variant_title || '';
    return {
      event_id: uid(),
      occurred_at: nowIso(),
      product_id: productId,
      product_title: text(title),
      product_handle: text(item.handle),
      variant_id: variantId,
      variant_title: text(variantTitle),
      size: extractSize(item),
      sku: text(item.sku),
      quantity: Number(item.quantity || 1),
      price_cents: Number(item.final_price != null ? item.final_price : (item.price || 0)),
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || '',
      page_path: window.location.pathname,
      page_url: window.location.href,
      referrer: document.referrer || '',
      market_country: (window.Shopify && Shopify.country) || '',
      locale: document.documentElement.lang || ''
    };
  }

  function remember(payload) {
    try {
      var rows = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(rows)) rows = [];
      rows.unshift(payload);
      if (rows.length > MAX_EVENTS) rows.length = MAX_EVENTS;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(rows));
    } catch (e) {}
  }

  function publish(payload) {
    if (!payload) return;

    remember(payload);

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(EVENT_NAME, payload);
      }
    } catch (e) {}

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'goc_cart_item_added_detail',
        goc_cart_item: payload
      });
    } catch (e) {}

    try {
      window.dispatchEvent(new CustomEvent('goc:cart-item-added', { detail: payload }));
    } catch (e) {}
  }

  function publishResponseData(data) {
    if (!data) return;
    var items = Array.isArray(data.items) ? data.items : [data];
    for (var i = 0; i < items.length; i++) {
      var payload = normalizeItem(items[i]);
      if (payload) publish(payload);
    }
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    try {
      var value = typeof url === 'string' ? url : (url.url || '');
      return /\/cart\/add(?:\.js)?(?:\?|$)/.test(value);
    } catch (e) {
      return false;
    }
  }

  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var request = args[0];
      var promise = originalFetch.apply(this, args);

      if (isCartAddUrl(request)) {
        promise.then(function (response) {
          if (!response || !response.ok) return;
          response.clone().json().then(publishResponseData).catch(function () {});
        }).catch(function () {});
      }

      return promise;
    };
  }

  if (window.XMLHttpRequest) {
    var OriginalXHR = window.XMLHttpRequest;
    var originalOpen = OriginalXHR.prototype.open;
    var originalSend = OriginalXHR.prototype.send;

    OriginalXHR.prototype.open = function (method, url) {
      this.__gocCartAddUrl = isCartAddUrl(url);
      return originalOpen.apply(this, arguments);
    };

    OriginalXHR.prototype.send = function () {
      if (this.__gocCartAddUrl) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) return;
          try {
            publishResponseData(JSON.parse(this.responseText));
          } catch (e) {}
        });
      }
      return originalSend.apply(this, arguments);
    };
  }
})();
